<template>
  <b-modal
    id="form-modal"
    size="xl"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    no-fade
    @show="onShow"
    @hidden="onHidden"
  >
    <template #modal-header>
      <h5 class="modal-title">DSMES PLAN FORM</h5>
      <button type="button" class="close" @click="closeModal" :disabled="isClosing">×</button>
    </template>

    <div v-show="isLoading || isClosing" class="text-center py-5">
      <b-spinner variant="success" label="Loading..."></b-spinner>
      <p class="mt-2 text-muted">{{ isClosing ? 'Đang đóng form...' : 'Đang tải form...' }}</p>
    </div>

    <CoachComment
      v-if="!isLoading && !shouldDestroy"
      v-show="!isClosing"
      :coachList="coachList"
      :targetItem="targetItem"
      @closeModal="closeModal"
    />
  </b-modal>
</template>

<script>
import CoachComment from '@/view/pages/coaches_calendar/components/CoachCommentPage.vue'

export default {
  name: 'FormModal',
  components: {
    CoachComment,
  },
  props:{
    targetItem: {
      type: Object,
      required: true,
    },
    coachList: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      isClosing: false,
      shouldDestroy: false,
    }
  },
  methods: {
    onShow() {
      this.isLoading = true;
      this.isClosing = false;
      this.shouldDestroy = false;
      setTimeout(() => {
        this.isLoading = false;
      }, 50);
    },
    onHidden() {
      this.isLoading = true;
      this.isClosing = false;
      this.shouldDestroy = false;
      this.$store.commit('context/setLoading', false);
    },
    closeModal() {
      if (this.isClosing) return;
      // Step 1: Hide component with v-show (instant, shows spinner)
      this.isClosing = true;
      // Step 2: Force browser to paint spinner (setTimeout 0 + rAF ensures paint)
      setTimeout(() => {
        requestAnimationFrame(() => {
          // Step 3: Destroy component (freeze happens here but spinner is visible)
          this.shouldDestroy = true;
          // Step 4: Close modal after destruction
          this.$nextTick(() => {
            this.$bvModal.hide('form-modal');
          });
        });
      }, 50);
    },
  },
}
</script>

<style scoped>
</style>
